import config from "./config";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueCookie from 'vue-cookie'
import Loading from './components/loading/index'
import wxSDK from "@/utils/wxSDK";
import { isWechatBrowser } from "@/utils/tool";
Vue.config.productionTip = false;

Vue.prototype.$config = config;
import './assets/font/fonts.css';
import './assets/scss/public.css';
import './assets/scss/index.scss';
import animated from 'animate.css'
import './utils/rem'
import MetaInfo from 'vue-meta-info'
import maima from '@/utils/maima'

Vue.use(MetaInfo)
Vue.use(animated)
Vue.use(Loading)
Vue.use(VueCookie);
Vue.use(maima);
import lineClamp from 'vue-line-clamp'
//引入nprogress
// import NProgress from 'nprogress' // 进度条
// import 'nprogress/nprogress.css' //这个样式必须引入
Vue.use(lineClamp, {
  importCss: true,
  fallbackFunc:function(el, bindings, lines) {
    if (lines) {
      let lineHeight = parseInt(bindings.arg) || parseInt(el.currentStyle['lineHeight']);
      if (isNaN(lineHeight)) {
        console.warn(
            'line-height argument for vue-line-clamp must be a number (of pixels), falling back to 16px'
        );
        lineHeight = 16;
      }

      let maxHeight = lineHeight * lines;

      el.style.maxHeight = maxHeight ? maxHeight + 'px' : '';
      el.style.overflowX = 'hidden';
      el.style.lineHeight = lineHeight + 'px'; // to ensure consistency
    } else {
      el.style.maxHeight = el.style.overflowX = '';
    }
  }
})
import '../node_modules/swiper/css/swiper.css'
//苹果文本框输入页面上滑问题
document.body.addEventListener('focusout', (event) => {
  if (document.documentElement.clientWidth >= 750) return;
  if (!!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
    setTimeout(() => {
      const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
      window.scrollTo(0, Math.max(scrollHeight - 1, 0));
    }, 100);
  }
});

new Vue({
  router,
  store,
  render: h => h(App),
  //添加到这里,这里的render-event和vue.config.js里面的renderAfterDocumentEvent配置名称一致
  mounted () {
    document.dispatchEvent(new Event('render-event'))
    if(process.env.VUE_APP_FLAG === 'pro'){
      var _hmt = _hmt || [];
      (function() {
        var hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?ebc19b037353c9300a21683751f14133";
        var s = document.getElementsByTagName("script")[0]; 
        s.parentNode.insertBefore(hm, s);
      })();
    }
  }
}).$mount("#app");
// router.beforeEach((to, from, next) => {
//   // NProgress.start();
//   if (window._hmt) {
//     //百度埋码
//     if (to.path) {
//       if(window.location.href.indexOf('partner2020-minisite')>-1)
//       {
//         window._hmt.push(['_trackPageview', '/campaign/partner2021-minisite' + to.fullPath]);
//       }
//       else {
//         window._hmt.push(['_trackPageview', '/campaign/ecopartner2021' + to.fullPath]);
//       }
//     }
//   }
//   if(to.path === '/home' && from.query.routeFrom==='home') {
//     to.meta.keepAlive = true
//   } else {
//     to.meta.keepAlive = false
//   }
//   next()
// });
// router.afterEach(transition => {
//   // NProgress.done();
// });
router.afterEach((to, from) => {
  //初始化微信分享
  if (!isWechatBrowser()) {
    return;
  }else{
    wxSDK.init().then(wx => {
      let desc = window.$config.shareDesc.replace('{module}', '-'+to.name);
      let params = {
        title: window.$config.shareTitle, // 分享标题
        desc: desc, // 分享描述
        link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: window.$config.shareImgUrl, // 分享图标
        success: function() {
        },
        fail: function() {
        }
      };
      wx.updateAppMessageShareData(params);
      wx.updateTimelineShareData(params);
    });
  }
});
